'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matrixJsSdk = require('matrix-js-sdk');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageOverlay = function (_PureComponent) {
    (0, _inherits3.default)(MessageOverlay, _PureComponent);

    function MessageOverlay() {
        (0, _classCallCheck3.default)(this, MessageOverlay);
        return (0, _possibleConstructorReturn3.default)(this, (MessageOverlay.__proto__ || (0, _getPrototypeOf2.default)(MessageOverlay)).apply(this, arguments));
    }

    (0, _createClass3.default)(MessageOverlay, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                mxEvent = _props.mxEvent,
                reactions = _props.reactions,
                isLast = _props.isLast,
                tsSuffix = _props.tsSuffix;


            var MessageTimestamp = _index2.default.getComponent('messages.MessageTimestamp');

            var timestamp = mxEvent.getTs() ? _react2.default.createElement(MessageTimestamp, { showTwelveHour: false, ts: this.props.mxEvent.getTs(), isLast: isLast, suffix: tsSuffix }) : null;

            var MessageActionBar = _index2.default.getComponent('messages.MessageActionBar');
            var actionBar = _react2.default.createElement(MessageActionBar, {
                mxEvent: this.props.mxEvent,
                reactions: reactions,
                permalinkCreator: this.props.permalinkCreator,
                getTile: this.getTile,
                getReplyThread: this.getReplyThread,
                onFocusChange: this.onActionBarFocusChange
            });

            return _react2.default.createElement(
                _react.Fragment,
                null,
                actionBar,
                timestamp
            );
        }
    }]);
    return MessageOverlay;
}(_react.PureComponent);

MessageOverlay.contextTypes = {
    matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient).isRequired
};
exports.default = MessageOverlay;
module.exports = exports['default'];
//# sourceMappingURL=MessageOverlay.js.map